/* api */
import {
  getAllForms,
  getAllDrafts,
  getAllDispatches,
} from 'apps/web_forms/api/api';
import { ORIGINS } from 'apps/web_forms/utils/constants';

const findSelectedForm = async (id, params) => {
  let paramsFormType = params.origin ?? ORIGINS.Form;
  let forms = [];

  switch (paramsFormType) {
    case 'form':
      forms = await getAllForms();
      break;
    case 'dispatch':
      forms = await getAllDispatches();
      break;
    case 'submission':
      forms = await getAllForms(); //since there is no API call for submissions, then we will use the forms API
      break;
    case 'draft':
      forms = await getAllDrafts();
      break;
    default:
      forms = await getAllForms();
      break;
  }

  const foundSelectedForm = forms.find((form) => form.identifier == id);

  return { foundSelectedForm, forms };
};

export default findSelectedForm;